import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./InfoFieldsPosition.css";

const InfoFieldsPosition = ({
  control,
  register,
  index,
  indexAdPosition,
  indexPosition,
  indexPositionDetails,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields`,
  });

  return (
    <div className="form-wrapper">
      <ul>
        {fields.map((item, indexInfoFields) => {
          return (
            <li key={item.id} className="form-wrapper-info-fields">
              <h4>HTML File Information Fields</h4>
              <div className="input-container">
                <div className="inner-input-container">
                  <InputFieldFormArray
                    label="Subject "
                    placeholder="Dimensions / Weight / etc."
                    fieldRef={register(
                      `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].subject`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].subject`}
                    key={item.id + 1}
                  />

                  <InputFieldFormArray
                    label="Text "
                    placeholder="300x250 / 300KB max"
                    fieldRef={register(
                      `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].text`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].text`}
                    key={item.id + 2}
                  />

                  <section className="select-wrapper">
                    <div className="label-wrapper">
                      <label>Type </label>
                    </div>
                    <div>
                      <select
                        {...register(
                          `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].type`,
                          { required: false }
                        )}
                      >
                        <option value="text">text</option>
                        <option value="url">url</option>
                      </select>
                    </div>
                  </section>

                  <InputFieldFormArray
                    label="Url "
                    fieldRef={register(
                      `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].url`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].infoFields[${indexInfoFields}].url`}
                    key={item.id + 3}
                  />

                  <button
                    className="info-fields-position-button delete-button"
                    type="button"
                    onClick={() => {
                      remove(indexInfoFields);
                    }}
                  >
                    Delete <br /> HTML Information Fields
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <button
        className="append-button"
        type="button"
        onClick={() => {
          append({ subject: "", text: "", type: "text", url: "" });
        }}
      >
        Add <br /> HTML Information Fields
      </button>
    </div>
  );
};

export default InfoFieldsPosition;
